module.exports = __webpack_public_path__ + "img/reciclaje-de-aceite.4469b2ac.png";